import { InputAdornment, MenuItem, Select } from "@mui/material";
import { LEVEL_OPTIONS } from "../../enums/recruitment";
import FilterPosition from "./components/filter-postition";
import FilterAddress from "./components/filter-address";

function RecruitmentToolbar({ filters, handleUpdateFilters, handleSearch }) {
  return (
    <div className="p-4 bg-white rounded-2xl mt-2">
      <div className="flex gap-6">
        <input
          className="flex-1 bg-[#fafafa] px-4 rounded-lg h-[48px] md:h-auto"
          placeholder="Tìm kiếm công việc"
          value={filters.keyword}
        />
        <button
          onClick={handleSearch}
          className="bg-[#1C9BDB] rounded-2xl text-white px-7 py-4 w-[180px] h-[54px] md:block hidden"
        >
          Tìm kiếm
        </button>
      </div>
      <div className="flex-col md:flex-row flex mt-4 gap-3 md:gap-6 items-center">
        <FilterPosition
          value={filters.position}
          onChange={(value) => handleUpdateFilters("position", value)}
        />

        <div className="w-full sm:w-[1px] h-[1px] sm:h-12 bg-[#C7C7C7]"></div>
        <Select
          value={filters.level}
          fullWidth
          onChange={(event) =>
            handleUpdateFilters("level", +event.target.value)
          }
          sx={{ "&.MuiOutlinedInput-root ": { borderRadius: 2 } }}
          startAdornment={
            <InputAdornment position="start">
              <img src="/assets/icons/ic_user_star.svg" className="w-5 h-5" />
            </InputAdornment>
          }
        >
          {LEVEL_OPTIONS.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.title}
            </MenuItem>
          ))}
        </Select>

        <div className="w-full sm:w-[1px] h-[1px] sm:h-12 bg-[#C7C7C7]"></div>

        <FilterAddress
          value={filters.address}
          onChange={(value) => handleUpdateFilters("address", value)}
        />
      </div>
      <button
        onClick={handleSearch}
        className="bg-[#1C9BDB] rounded-2xl text-white px-7 mt-4 w-full h-[48px] sm:hidden"
      >
        Tìm kiếm
      </button>
    </div>
  );
}

export default RecruitmentToolbar;
